import { render, staticRenderFns } from "./Finish20.vue?vue&type=template&id=d5d99600&scoped=true&"
import script from "./Finish20.vue?vue&type=script&lang=js&"
export * from "./Finish20.vue?vue&type=script&lang=js&"
import style0 from "./Finish20.vue?vue&type=style&index=0&id=d5d99600&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d99600",
  null
  
)

export default component.exports